import React, { useContext, useEffect, useState } from "react";
import HotelSearchBar from "../components/HotelSearchBar";
import SingleHotelRoomCard from "../components/SingleHotelRoomCard";
import Footer from "../components/Footer";
import ErrorAlert from "../admin/components/ErrorAlert";
import NothingToShow from "../components/NothingToShow";
import { SearchContext } from "../context/HotelRoomSearch";
import { useParams } from "react-router-dom";

export default function BookNow() {

  // Params of url
  const { place } = useParams();

  // Context
  const { searchValues, setSearchValues } = useContext(SearchContext);

  // State
  const [error, setError] = useState("");
  const [fetchedHotels, setFetchedHotels] = useState([]);

  // --------- Reading/Fetching Hotels From Database ---------
  const readingHotels = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-hotels");
    const result = await response.json();

    if (!response.ok) {
      setError("Sorry, Something went wrong");
    } else if (response.ok) {
      setError("");
      setFetchedHotels(result);
    }
  };

  // Search by place/city that we have in the url
  const searchByCity = () => {
    if(place){
      setSearchValues({
        ...searchValues,
        location: place.toLowerCase(),
      });
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    readingHotels();
    searchByCity();
  }, []);

  // Filtering Hotels Based on the search
  const searchResult = fetchedHotels?.filter((hotel) => {
    const hotel_complete_location_spaces = hotel.hotel_complete_location
      .split(",")
      .join("");
    return (
      hotel.hotel_complete_location.includes(
        searchValues.location.toLowerCase()
      ) ||
      hotel_complete_location_spaces.includes(
        searchValues.location.toLowerCase()
      )
    );
  });

  return (
    <>
      {/* Hero Section Section Start */}
      {/* Heading */}
      <div className="container-fluid p-0 hero-section-spacing">
        <div className="row app-container">
          <h3 className="search-for-room-heading search-hotel-bookNow-heading mt-3 p-0">
            Search The Best Hotel For You
          </h3>
        </div>
      </div>

      {/* Search Bar Start */}
      <div className="bookNow-search-bar">
        <HotelSearchBar />
      </div>
      {/* Search Bar End */}
      {/* Hero Section End */}

      {/* Hotel Cards Sections Start */}
      <div className="container-fluid p-0 bookNow-hotel-cards">
        <div className="row cards-container">
          {/* Showing Alert based on http request response if hotels can't be fetched Start */}
          {error && <ErrorAlert errorMsg={error} />}
          {/* Showing Alert based on http request response if hotels can't be fetched End */}

          {!searchResult.length ? <NothingToShow text="Getting The Hotels..." /> : ""}

          {searchResult?.map((singleHotel) => {
            return (
              <SingleHotelRoomCard
                key={singleHotel._id}
                id={singleHotel._id}
                img={singleHotel.hotel_img}
                title={singleHotel.hotel_name}
                rating={singleHotel.hotel_rating}
                ratingReview={singleHotel.hotel_rating_review}
                cityAsLocation={singleHotel.hotel_city}
                perDayPrice={singleHotel.hotel_per_day_price}
                mb="4"
              />
            );
          })}
        </div>
      </div>
      {/* Hotel Cards Sections End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
